import { GutterCap, Header } from '@adserve/adserve-react-components';
import React, { useState } from 'react';
import { panelTitleStyle } from './BespokeBillingStyles';
import BespokeInvoiceListRow from './BespokeInvoiceListRow';

const BespokeInvoiceList = ({ invoices = [], onEditInvoice, onDeleteInvoice, calcVatRate, isSAndP, disabled }) => {
    const [scrollPx, setScrollPx] = useState(0);
    const headerRowHeight = 40;
    const rowHeight = 30;
    const visibleRows = isSAndP ? 7 : 6;

    const paddingRows = () => {
        const paddingContent = [];
        for (let i = invoices?.length; i < visibleRows; i++) {
            paddingContent.push(
                <BespokeInvoiceListRow
                    key={i}
                    invoice={{}}
                    index={i}
                    scrollPx={scrollPx}
                    onScroll={setScrollPx}
                    scrollableLength={invoices.length * rowHeight}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                />
            );
        }
        return paddingContent;
    };

    // ASSP-6309 Narrative on Bespoke Billing Screen

    return (
        <div style={{ paddingRight: 59, marginTop: 30 }}>
            <span style={panelTitleStyle}>{window.translate('Invoice Totals')}</span>
            <div
                style={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: '48px 48px 340px repeat(7, minmax(max-content, auto)) 19px',
                    height: (rowHeight * (visibleRows)) + headerRowHeight,
                    overflowY: 'hidden',
                    marginTop: 5
                }}
            >
                <Header
                    rowHeight={headerRowHeight}
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    colSpan={2}
                    style={{ gridColumn: 'span 2', borderLeftWidth: 1 }}
                >
                    {window.translate('Actions')}
                </Header>
                <Header rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('Narrative')}
                </Header>
                <Header rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('Invoice Date')}
                </Header>
                <Header rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('P.O. Number')}
                </Header>
                <Header rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('Amount')}
                </Header>
                <Header rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('Commission')}
                </Header>
                <Header rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('Net')}
                </Header>
                <Header rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('VAT')}
                </Header>
                <GutterCap rowHeight={headerRowHeight} visibleRows={visibleRows} scrollPx={scrollPx}>
                    {window.translate('Invoice Total')}
                </GutterCap>
                {invoices?.map((invoice, i) => (
                    <BespokeInvoiceListRow
                        key={i}
                        index={i}
                        invoice={invoice}
                        calcVatRate={calcVatRate}
                        onEditInvoice={onEditInvoice}
                        onDeleteInvoice={onDeleteInvoice}
                        scrollPx={scrollPx}
                        onScroll={setScrollPx}
                        scrollableLength={invoices.length * rowHeight}
                        rowHeight={rowHeight}
                        visibleRows={visibleRows}
                        disabled={disabled}
                    />
                ))}
                {paddingRows()}
            </div>
        </div>
    );
};

export default BespokeInvoiceList;
